import { getPrefixFromPhoneCountry } from '../../models/serializable/phone-country.js';
import { PhoneNumber } from '../../models/serializable/phone-number.js';
import { PhoneNumberFormatter } from './phone-number-formatter.js';

export class HungarianPhoneNumberFormatter extends PhoneNumberFormatter {
  formattedNumber = '';

  format(phoneNumber: PhoneNumber): string {
    this.formattedNumber += getPrefixFromPhoneCountry(phoneNumber.country);
    this.formattedNumber += ' ';

    if(phoneNumber.number[0] === '1') {
      this.formattedNumber += phoneNumber.number.substring(0, 1);
      this.formattedNumber += ' ';
      this.formattedNumber += phoneNumber.number.substring(1, 4);
      this.formattedNumber += ' ';
      this.formattedNumber += phoneNumber.number.substring(4);
    }
    else {
      this.formattedNumber += phoneNumber.number.substring(0, 2);
      this.formattedNumber += ' ';
      this.formattedNumber += phoneNumber.number.substring(2, 5);
      this.formattedNumber += ' ';
      this.formattedNumber += phoneNumber.number.substring(5);
    }

    return this.formattedNumber;
  }
}
